module.exports = __webpack_public_path__ + "static/media/HiringHQ_Logo_Light.18db9422.png";